import React from 'react';

import { CircularProgress } from '@material-ui/core';
import PriorityHighRoundedIcon from '@material-ui/icons/PriorityHighRounded';
import { StyledTypography } from 'styles/common';

import { StyledIcon } from 'constants/icons';

import DeleteComponent from './DeleteComponent';
import { Previews, Preview, OverlayContainer, ImagePreview, ErrorContainer } from './styles';

export default function ImagePreviewComponent({ uploading, uploadedFile, fileUrl, deleteFile }) {
  return (
    fileUrl && (
      <Previews className="previewsContainer">
        <Preview className="previewContainer">
          <ImagePreview className="imagePreview" isUploaded={uploadedFile !== null} src={fileUrl} />
          <OverlayContainer className="overlayContainer">
            {!uploading && !uploadedFile && (
              <ErrorContainer className="errorContainer">
                <StyledIcon size="header">
                  <PriorityHighRoundedIcon />
                </StyledIcon>
                <StyledTypography variant="body2">Error</StyledTypography>
              </ErrorContainer>
            )}
            {!uploading && <DeleteComponent deleteImage={deleteFile} />}
            {uploading && <CircularProgress />}
          </OverlayContainer>
        </Preview>
      </Previews>
    )
  );
}
